// import React from "react";
// import { NavLink } from "react-router-dom";

const ActivePage = () => {
    return null;
    // return (
    // 	<div className="page-bar">
    // 		<div className="page-title-breadcrumb">
    // 			<div className=" pull-left">
    // 				<div className="page-title">{props.title}</div>
    // 			</div>
    // 			<ol className="breadcrumb page-breadcrumb pull-right">
    // 				<li>
    // 					<i className="fa fa-home"></i>&nbsp;
    // 					<NavLink className="parent-item" to="/home">
    // 						Home
    // 					</NavLink>
    // 					&nbsp;<i className="fa fa-angle-right"></i>
    // 				</li>
    // 				{props.pages.map((page, index) => {
    // 					if (
    // 						props.pages.indexOf(page) ===
    // 						props.pages.length - 1
    // 					) {
    // 						return (
    // 							<li key={index} className="active">
    // 								{page.title}
    // 							</li>
    // 						);
    // 					} else {
    // 						return (
    // 							<li key={index}>
    // 								<NavLink
    // 									className="parent-item"
    // 									to={page.path}
    // 								>
    // 									{page.title}
    // 								</NavLink>
    // 								&nbsp;<i className="fa fa-angle-right"></i>
    // 							</li>
    // 						);
    // 					}
    // 				})}
    // 			</ol>
    // 		</div>
    // 	</div>
    // );
};

export default ActivePage;
